import Indicator from '../Indicator';
import BandMarker from '../markers/BandMarker';
import LineMarker from '../markers/LineMarker';
import subpixel from '../util/canvasSubpixelOffset';

/** Percent B indicator */
export default class PercentBIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 * @property {string} description - Indicator description
	 * @property {object[]} inputs - Indicator inputs
	 * @property {object[]} bands - Indicator bands
	 */
	_getDefaultParams() {
		return {
			id: 'percentb',
			name: 'Bollinger Band %B',
			description:
				"%B quantifies a security's price relative to the upper and lower Bollinger Band.",
			inputs: [
				{ name: 'period', value: 20 },
				{ name: 'standardDeviations', value: 2, max: 10 }
			],
			bands: [
				{
					labelTranslationKey: 'band.overbought',
					valHigh: 10000, // effectively infinite
					valLow: 1
				},
				{
					labelTranslationKey: 'band.oversold',
					valHigh: 0,
					valLow: -10000 // effectively infinitely negative
				}
			],
			componentSeries: [
				{ id: 'percentb' }
			]
		};
	}

	/**
	 * @return {object}
	 * @property {LineMarker} line
	 * @property {BandMarker} overbought
	 * @property {BandMarker} oversold
	 */
	_getMarkers() {
		return {
			line: new LineMarker(),
			overbought: new BandMarker(this.params.bands[0], this.panel),
			oversold: new BandMarker(this.params.bands[1], this.panel)
		};
	}

	/**
	 *
	 * @param {CanvasRenderingContext2D} ctx - Chart canvas context
	 * @param {number} yScale - Y axis scale
	 */
	_renderMedianLine(ctx, yScale) {
		const left = this.panel.size.padding.left;
		const y0 = subpixel.px(yScale(0.5));
		const style = this.params.style;

		ctx.beginPath();
		ctx.lineWidth = style.median.width;
		ctx.strokeStyle = style.median.color;
		if (style.median.lineDash) ctx.setLineDash(style.median.lineDash.split(/\s*,\s*/));
		ctx.moveTo(left, y0);
		ctx.lineTo(this.panel.size.width + left, y0);
		ctx.stroke();
		ctx.setLineDash([]);
	}

	/** @param {object} data Symbol data object */
	render(data, sessionType) {
		this.markers.overbought.render(this.panel, this.params.style.overbought, true);
		this.markers.oversold.render(this.panel, this.params.style.oversold, false);
		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});

		this._renderMedianLine(this.panel.rootContext, this.yScale);
	}
}
